import { useDispatch, useSelector } from "react-redux";
import { Button, Input } from "@chakra-ui/react";
import { search } from "../store/utils";
import { setSearchTerm } from "../store/search";

export const SearchBar = () => {
  const dispatch = useDispatch();

  return <>
    <Input
      onKeyPress={(e) => e.key === "Enter" ? dispatch(search()) : ""}
      color={"yellow.200"}
      width="60%" variant="outline" onChange={(e) => dispatch(setSearchTerm({ searchTerm: e.target.value }))}
      placeholder="Search for keywords or phrases" />
    <Button
      onClick={() => {
        dispatch(search());
      }}
      colorScheme={"green"}
      _hover={{ bg: "green.500" }}
    >Search</Button>
  </>;
};